import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useIsClient } from '@yonderland/andes-react';
import { useDispatch, useSelector } from 'react-redux';
import ComparePopup from '../components/product-detail/compare-popup/ComparePopup';
import compareActions from '../redux/compare/actions/CompareActions.creators';
import { makeGetCompareState } from '../redux/compare/selectors/CompareSelectors';
export const ComparePopupContainer = ({ isStickyBar }) => {
    const { root } = useAemConfig();
    const isClient = useIsClient();
    const dispatch = useDispatch();
    const compareState = useSelector(makeGetCompareState());
    const updateCompareList = (product) => dispatch(compareActions.createUpdateInProductCompareBoxAction(product));
    const toggleComparePopup = () => dispatch(compareActions.createPopupToggleAction());
    const openComparePage = () => dispatch(compareActions.createPageOpenAction());
    const toggleLimitReached = (payload) => dispatch(compareActions.createToggleLimitReachedAction(payload));
    if (!isClient || compareState.items.length === 0) {
        return null;
    }
    return (_jsx(ComparePopup, { compareState: compareState, root: root, isStickyBar: isStickyBar, toggleComparePopup: toggleComparePopup, openComparePage: openComparePage, updateCompareList: updateCompareList, toggleLimitReached: toggleLimitReached }));
};
